import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AnnualReportProvider } from '@modeso/aumico-lib-annualreport-fe';
import { ARRAY_SIZE_OF_TWO_ELEMENTS, ModalComponent, ModalData, ModalTitleIcons } from '@modeso/aumico-lib-core-fe';
import { IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';
import Debug from 'debug';
import { filter, first, mergeMap, Observable, of, tap } from 'rxjs';
import { Paths } from '../../../enums/paths.enum';
const debug = Debug('aumico:project-reports-fe:CanActive:GroupingAndMaskingGuard');
@Injectable({
    providedIn: 'root',
})
export class GroupingAndMaskingGuard implements CanActivate {
    private shouldNavigateToGroupingAndMasking = false;

    constructor(
        private router: Router,
        private annualReportsProvider: AnnualReportProvider,
        private dialog: MatDialog,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.annualReportsProvider.getActiveAnnualReport$().pipe(
            filter((activeAnnualReport) => activeAnnualReport != null && activeAnnualReport.generalInformation != null),
            tap((activeAnnualReport) => this.checkIfMappingExists(activeAnnualReport)),
            mergeMap(() => {
                if (this.shouldNavigateToGroupingAndMasking) {
                    this.shouldNavigateToGroupingAndMasking = false;
                    return of(true);
                }

                const previousUrl = this.router.routerState.snapshot.url;
                const parentUrl = state.url.slice(0, state.url.indexOf(route.url[route.url.length - 1].path));

                if (previousUrl === parentUrl + Paths.MAPPING) {
                    this.openDialog();
                }
                const url = this.router.parseUrl(parentUrl);
                this.router.navigate([parentUrl, `${Paths.MAPPING}`], { state: { skipChangeDetection: true } });

                return of(false);
            }),
            first(),
        );
    }

    private checkIfMappingExists(activeAnnualReport: IAnnualReport): void {
        if (
            //It's ok here to access directly the .finStatements of annual report
            activeAnnualReport.finStatements != null &&
            activeAnnualReport.finStatements.length === ARRAY_SIZE_OF_TWO_ELEMENTS
            && activeAnnualReport.finStatements[0].templateAndAccountsMapping?.template != null
            && activeAnnualReport.finStatements[1].templateAndAccountsMapping?.template != null
        ) {
            this.shouldNavigateToGroupingAndMasking = true;
        } else {
            this.shouldNavigateToGroupingAndMasking = false;
        }
    }

    private openDialog(): void {
        this.dialog.open<ModalComponent, ModalData, void>(ModalComponent, {
            disableClose: false,
            panelClass: 'custom-modalbox',
            data: {
                showCloseButton: true,
                titleIcon: ModalTitleIcons.INFO,
                footerButtons: [],
                content: {
                    text: ['aumico_annual_report_mapping_page_can_not_navigate_to_grouping_and_masking_dialog_description'],
                    icon: 'document-information',
                },
            },
        });
    }
}
